import React from 'react';
import styled from "styled-components";
import { Pill } from '@shared/ui/atoms/Pill';
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { tablet } from '@shared/ui/atoms/MediaQueries';

export function VisitorBookingColumnHeaders(props: Props) {
  return (
    <Container>
      <PillWrapper style={{marginLeft: 10}} colour={Colours.white} backgroundColour={Colours.darkBlue}>
        <BodyVerySmall>Time In</BodyVerySmall>
      </PillWrapper>
      <PillWrapper style={{marginLeft: 60}} colour={Colours.white} backgroundColour={Colours.darkBlue}>
        <BodyVerySmall>Visitor</BodyVerySmall>
      </PillWrapper>
      <PillWrapper style={{marginLeft: 260}} colour={Colours.white} backgroundColour={Colours.darkBlue}>
        <BodyVerySmall>Meeting With</BodyVerySmall>
      </PillWrapper>
    </Container>
  )
}

interface Props {
}

const PillWrapper = styled(Pill)`
  padding: 8px 12px;
`

const Container = styled.div`
  display: none;
  border-radius: 62px;
  margin-bottom: 24px;
  background-color: white;
  padding: 10px 12px 8px 12px;
  margin-right: 24px;
  @media (${tablet}) {
    display: flex;
  }
`
